import $http from './http'
import config from './config'

export default {
  name: 'tour',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  RefundJudge(UniqueID) {
    return $http.get(this.getUrl(`/TourOrder/RefundJudge?UniqueID=${UniqueID}`));
  },
  OrderCancel(id) {
    return $http.get(this.getUrl(`/TourOrder/OrderCancel?UniqueID=${id}`));
  },
  OrderSubmit(UniqueID) {
    return $http.get(this.getUrl(`/TourOrder/OrderSubmit/${UniqueID}`));
  },
  OrderRefund(data) {
    return $http.post(this.getUrl('/TourOrder/OrderRefund'), data);
  },
  CreateOrderByPreference(data) {
    return $http.post(this.getUrl('/TourOrder/CreateOrderByPreference'), data);
  },
  SearchOrders(id) {
    return $http.get(this.getUrl(`/TourOrder/SearchOrders?UniqueID=${id}`));
  },
  OrderRefundCancel(id) {
    return $http.get(this.getUrl(`/TourOrder/OrderRefundCancel?UniqueID=${id}`));
  },
}



// WEBPACK FOOTER //
// ./src/apis/tourApis.js